import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRM

const AdminOnboardingShareConfirm = props => (<Confirm
	btOne={localize('admin_onboarding_invite_teachers_confirm_btn_one_2')}
	btTwo={localize('admin_onboarding_invite_teachers_confirm_btn_two')}
	alertTitle={localize('admin_onboarding_invite_teachers_confirm_title')}
	alertMessage={''}
	actionButtonType={0}
	actionOne={() => props.actions.shareConfirmed(CONFIRM_TYPE)}
	actionTwo={() => props.actions.cancelShareConfirmed(CONFIRM_TYPE)}
	centeredTitle={true}
	closeAction={() => props.actions.cancelShareConfirmed(CONFIRM_TYPE)}
/>)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		shareConfirmed: adminOnboardingActions.shareConfirmed,
		cancelShareConfirmed: adminOnboardingActions.cancelShareConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(AdminOnboardingShareConfirm)
